import React, { useState } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createOverride } from "../../../redux/Overrides/actions";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const AddOverrideButton = ({ onRefresh = () => {} }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const capabilities = useSelector((state) => state.capabilities.capabilities);
  const resources = useSelector((state) => state.resources.resources);

  const showModal = () => {
    setVisible(true);
  };

  const hideModalOk = () => {
    form.submit();
  };

  const formOnFinish = (data) => {
    dispatch(createOverride(data)).then(() => {
      form.resetFields();
      setVisible(false);
      onRefresh(); // Call onRefresh to refetch the data
    });
  };

  const hideModalCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Override
      </Button>
      <Modal
        title="Add Override"
        visible={visible}
        onOk={hideModalOk}
        onCancel={hideModalCancel}
        okText="Submit"
        cancelText="Close"
      >
        <Form
          {...layout}
          name="basic"
          form={form}
          onFinish={formOnFinish}
          initialValues={{ remember: false }}
        >
          <Form.Item
            label="Override Name"
            name="name"
            rules={[{ required: true, message: "Please enter the override name!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Default Capabilities"
            name="defaultCapabilities"
          >
            <Select mode="multiple" placeholder="Select default capabilities">
              {capabilities.map((capability) => (
                <Select.Option key={capability._id} value={capability._id}>
                  {capability.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Default Resources"
            name="defaultRessources"
          >
            <Select mode="multiple" placeholder="Select default resources">
              {resources.map((resource) => (
                <Select.Option key={resource._id} value={resource._id}>
                  {resource.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddOverrideButton;
